<template>
  <div class="token-redirect-screen d-flex flex-column align-items-center justify-content-center p-3">
    <div class="token-redirect-card text-center">
      <h1 class="token-redirect-title mb-2">
        Estação Energy2Go {{ pointName }} - {{ token }}
      </h1>
      <p class="token-redirect-subtitle mb-3 text-uppercase">
        CLIQUE AQUI PARA ALUGUAR UM CARREGADOR PORTÁTIL
      </p>
      <div class="token-redirect-loader d-flex align-items-center justify-content-center gap-2">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span class="visually-hidden">Carregando...</span>
        </div>
        <span class="token-redirect-status">Conectando...</span>
      </div>
    </div>
  </div>
</template>

<script>
  import getPointByToken from '@/services/getPointName'
  import { UserEvent, sessionRecorder } from '@/services/sessionRecorder'
  import { captureException } from '@/errors'
  import { TOKENS_PARTNERS } from '@/constants'

  const TAG_TOKEN_REDIRECT = 'token_redirect'

  export default {
    name: 'TokenRedirect',
    data() {
      return {
        token: null,
        pointName: ''
      }
    },
    async created() {
      console.log('[TokenRedirect] Componente criado')
      this.token = this.$route.params.token

      if (!this.token) {
        this.$router.push({ name: 'error' })
        return
      }

      const trimmedToken = this.token.trim()
      this.updateSeoMetadata(trimmedToken)

      try {
        console.log(`[TokenRedirect] Token esperado: '${TOKENS_PARTNERS.PINAPPLES.token}'`)
        this.handlePartnerToken(trimmedToken)
        this.handleLightComPoint(trimmedToken)

        const point = await getPointByToken(this.token)

        if (point && point.success) {
          this.handlePointSuccess(point)
        } else {
          captureException('Token redirect: ponto não encontrado ou falha na resposta', null, { token: this.token })
        }
      } catch (error) {
        captureException('Erro ao processar token de redirecionamento', error, { token: this.token })
      } finally {
        const isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)
        if (!isBot) {
          this.$router.push({ name: 'home_page' })
        }
      }
    },
    methods: {
      updateSeoMetadata(trimmedToken) {
        const fullUrl = `https://m.energy2go.app/qr/${trimmedToken}`
        document.title = fullUrl

        let canonicalLink = document.querySelector("link[rel='canonical']")
        if (!canonicalLink) {
          canonicalLink = document.createElement('link')
          canonicalLink.setAttribute('rel', 'canonical')
          document.head.appendChild(canonicalLink)
        }
        canonicalLink.setAttribute('href', fullUrl)

        let metaDesc = document.querySelector("meta[name='description']")
        if (!metaDesc) {
          metaDesc = document.createElement('meta')
          metaDesc.setAttribute('name', 'description')
          document.head.appendChild(metaDesc)
        }
        metaDesc.setAttribute('content', `${fullUrl} - Acesse diretamente a estação ${trimmedToken}.`)
      },
      handlePartnerToken(trimmedToken) {
        if (trimmedToken !== TOKENS_PARTNERS.PINAPPLES.token) {
          return
        }

        console.log(`[TokenRedirect] Token de parceiro identificado: ${TOKENS_PARTNERS.PINAPPLES.name}`)
        try {
          sessionStorage.setItem('partner_name', TOKENS_PARTNERS.PINAPPLES.name)

          if (this.$partner) {
            this.$partner.setPartner(TOKENS_PARTNERS.PINAPPLES.name)
          } else {
            console.warn('[TokenRedirect] $partner não está disponível')
          }
        } catch (error) {
          console.error('[TokenRedirect] Erro ao configurar parceiro:', error)
        }
      },
      handleLightComPoint(trimmedToken) {
        const envPoints = import.meta.env.VITE_LIGHTCOM_POINTS || ''
        const lightComPoints = envPoints.split(',').map(p => p.trim())

        const foundPoint = lightComPoints.find(point => point && trimmedToken && trimmedToken.includes(point))
        if (foundPoint) {
          sessionStorage.setItem('point_id_token_selection', foundPoint)
        }
      },
      handlePointSuccess(point) {
        this.pointName = point.name
        localStorage.setItem('terminal_token', this.token)
        localStorage.setItem('point_name', point.name)
        sessionStorage.setItem('point_id_qr', point.id)
        localStorage.setItem('point_id', point.id)
        localStorage.setItem('show_payment_info', String(point.show_payment_info))
        sessionStorage.setItem('qr_token', this.token)

        sessionRecorder.addUserEvent(new UserEvent(TAG_TOKEN_REDIRECT, null, { token: this.token }))
      }
    }
  }
</script>

<style scoped lang="scss">
  @use '@/main';

  .token-redirect-screen {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: linear-gradient(135deg, main.$color-energy-blue 0%, main.$color-energy-light-blue 60%, #1579be 100%);
    z-index: 1000;
  }

  .token-redirect-logo {
    width: 180px;
    max-width: 60%;
    height: auto;
    filter: drop-shadow(0 4px 8px rgb(0 0 0 / 25%));
  }

  .token-redirect-card {
    width: 100%;
    max-width: 320px;
    padding: 24px 20px;
    border-radius: 20px;
    background: rgb(255 255 255 / 95%);
    backdrop-filter: blur(16px);
    box-shadow: 0 8px 32px rgb(0 0 0 / 15%);
  }

  .token-redirect-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: main.$color-energy-dark-gray;
    line-height: 1.3;
  }

  .token-redirect-subtitle {
    font-size: 0.85rem;
    font-weight: 600;
    color: main.$color-energy-orange;
    letter-spacing: 0.02em;
    line-height: 1.4;
  }

  .token-redirect-status {
    font-size: 0.8rem;
    color: main.$color-energy-dark-gray;
    opacity: 0.8;
  }
</style>